/**
 * Normalização e máscara do telefone, portadas de `atalia/src/lib/phone.ts`
 * (mesmo contrato: só dígitos, prefixo `55` garantido, celular completo
 * = 13 dígitos).
 */

const COUNTRY_CODE = '55'
const REQUIRED_DIGITS = 13

const AREA_CODE_START = 2
const AREA_CODE_END = 4
const SUBSCRIBER_SPLIT = 9

const NON_DIGIT = /\D/g
const LEADING_ZEROS = /^0+/

export function normalizePhone(input: string): string {
  const digits = input.replace(NON_DIGIT, '')
  const withCountryCode = digits.startsWith(COUNTRY_CODE)
    ? digits
    : `${COUNTRY_CODE}${digits.replace(LEADING_ZEROS, '')}`

  return withCountryCode.slice(0, REQUIRED_DIGITS)
}

export function formatPhoneMask(input: string): string {
  const digits = normalizePhone(input)
  let formatted = `+${COUNTRY_CODE}`

  if (digits.length > AREA_CODE_START) {
    formatted += ` (${digits.slice(AREA_CODE_START, AREA_CODE_END)}`
  }

  if (digits.length > AREA_CODE_END) {
    formatted += `) ${digits.slice(AREA_CODE_END, SUBSCRIBER_SPLIT)}`
  }

  if (digits.length > SUBSCRIBER_SPLIT) {
    formatted += `-${digits.slice(SUBSCRIBER_SPLIT)}`
  }

  return formatted
}

export function isCompletePhone(input: string): boolean {
  return normalizePhone(input).length === REQUIRED_DIGITS
}

export function buildWhatsAppLink(phoneNumber: string, message: string): string {
  return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
}
